import { useAtomValue } from 'jotai'
import { userSettingsAtom } from '../../../store/atoms'
import { ETableColor } from '../../../store/atoms/userSettings'
import type { ERound } from './../../../types/enums'
import { ModeIcon, TableContent } from '../../molecules'
import { TablePlayers } from '../../organisms'
import { tableSourceByColor } from './constants'
import { usePokerRoomLogic } from './hooks'
import { inactiveMode, modesRow, room } from './index.css'
import type { PokerRoomPropsType } from './types'

export const PokerRoom = (props: PokerRoomPropsType) => {
  const userSettings = useAtomValue(userSettingsAtom)

  const logic = usePokerRoomLogic({
    table: props.table,
    players: props.players,
    userSeat: props.userSeat,
    pots: props.pots,
    tableInfo: props.tableInfo,
    userId: props.userId,
    winners: props.winners,
  })

  return (
    <div
      className={room}
      style={{
        backgroundImage: `url(${tableSourceByColor[userSettings.tableSettings.tableColor || ETableColor.GREEN]})`,
      }}
    >
      <TablePlayers
        userId={props.userId}
        userSeat={props.userSeat ?? null}
        offset={logic.playersOffset}
        round={props.table.round as ERound}
        turnSeconds={props.tableInfo.turnSeconds}
        turnRemainSeconds={logic.turnTimeout}
        playerTurnId={props.table.playerTurnId}
        dealerSeat={props.table.dealerSeat}
        players={props.players}
        maxPlayers={props.tableInfo.maxPlayers}
        bigBlind={props.tableInfo.bigBlind}
        currency={props.tableInfo.currency}
        plugMode={props.userSeat !== null ? 'invite' : 'sit'}
        communityCards={props.table.cards}
        secondBoard={props.table.secondBoard}
        winners={props.winners}
        playerResults={logic.playerResults}
        chatMessage={props.chatMessage}
        handNumber={props.table.handNumber}
        isSnapshot={props.isSnapshot}
        renderUserPlayer={props.renderUserPlayer}
        onClickPlayerPlug={props.onClickPlayerPlug}
        onPlayerMove={props.onPlayerMove}
        onPlayerWin={props.onPlayerWin}
      >
        <TableContent
          gameType={props.tableInfo.gameType}
          valuesInBigBlinds={props.valuesInBigBlinds}
          smallBlind={props.tableInfo.smallBlind}
          bigBlind={props.tableInfo.bigBlind}
          code={props.tableInfo.code}
          name={props.tableInfo.name}
          currency={props.tableInfo.currency}
          cards={props.table.cards}
          secondBoard={props.table.secondBoard}
          pots={props.pots}
          handNumber={props.table.handNumber}
          secondBoardHandName={logic.userSecondHandName}
          onNewCards={props.onNewTableCards}
        />
      </TablePlayers>
      <div className={modesRow}>
        {props.modes.bombPot ? (
          <ModeIcon
            mode='bombPot'
            placement='bottom'
            params={props.modes.bombPot}
            className={
              props.modes.bombPot.state === 'inactive'
                ? inactiveMode
                : undefined
            }
          />
        ) : null}
        {props.modes.doubleBoard ? (
          <ModeIcon
            mode='doubleBoard'
            placement='bottom'
            className={
              props.modes.doubleBoard === 'inactive' ? inactiveMode : undefined
            }
          />
        ) : null}
      </div>
    </div>
  )
}
